<template>
  <div class="banner-form form-style-1 form-style-3">
    <div class="container">
      <div class="form-content text-center">
        <div class="table-item">
          <label>選擇空間</label>
          <div class="form-group">
            <div class="date-range-inner-wrapper">
              <select v-model="room_key" @change.prevent="changeRoom">
                <option v-for="room in rooms" :value="room.key">{{room.title_and_ppl}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="table-item">
          <label>選擇日期</label>
          <div class="form-group">
            <div class="date-range-inner-wrapper">
              <datepicker
                maximum-view="day"
                v-model="date"
                :language="zh"
                :bootstrap-styling="true"
                :format="dateFormat"
                :disabled-dates="disabledDayRange"
                placeholder="請選擇預訂日期..."
                @selected="checkOrderDate"
              ></datepicker>
              <span class="input-group-addon">
              <i class="fa fa-calendar" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="table-item">
          <label>開始時間</label>
          <div class="form-group form-icon">
              <select v-model="selected_start_time" @change="changeStartTime" :disabled="date === null" class="form-control">
                <option :value="null" selected disabled>請先選擇日期</option>
                <option v-for="(time, index) in selectable_start_times" :value="[index, time[1]]">{{time[0]}}</option>
              </select>
          </div>
        </div>
        <div class="table-item">
          <label>結束時間</label>
          <div class="form-group form-icon">
            <select v-model="selected_end_time" :disabled="selected_start_time === null" class="form-control">
              <option :value="null" selected disabled>請先選擇開始時間</option>
              <option v-for="time in temp_selectable_end_times" :value="time[1]">{{time[0]}}</option>
            </select>
          </div>
        </div>
        <div class="table-item">
          <div class="form-btn mar-top-35">
            <button type="submit" class="btn btn-orange w100p" @click.prevent="goNewOrder">查看與預訂</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {zh} from 'vuejs-datepicker/dist/locale';
import { format } from 'date-fns';
import addDays from 'date-fns/addDays';
// import subDays from 'date-fns/subDays';
import axios from 'axios';

// 20251105 改成今日不能訂購了
export default {
  props: ['rooms'],
  data: function() {
    return {
      room_key: this.rooms[0].key,
      date: null,
      zh: zh,
      disabledDayRange: {
        to: new Date(), // 禁用到今天為止（包括今天），所以只能從明日開始選擇
        from: addDays(new Date(), 91)
      },
      selectable_start_times: [],
      selectable_end_times: [],
      temp_selectable_end_times: [],
      selected_start_time: null,
      selected_end_time: null,
    }
  },
  methods: {
    dateFormat(date) {
      return format(date, 'yyyy/MM/dd');
    },
    checkOrderDate(date) {
      const url = '/api/orders/check_date_orders';
      const formattedDate = this.dateFormat(date);
      const csrf = document.head.querySelector("meta[name=csrf-token]").content;
      axios.defaults.headers.common['X-CSRF-Token'] = csrf;
      axios.post(url, {
        date: formattedDate, key: this.room_key
      }).then((response) => {
        const {data} = response;
        // console.log(data);
        // this.taken_orders = data.orders;
        this.selectable_start_times = data.selectable_start_times;
        this.selectable_end_times = data.selectable_end_times;
        this.selected_start_time = null;
        this.selected_end_time = null;
        // this.price = data.price;
      }).catch(error => console.log(error));
    },
    changeStartTime() {
      const [start_times_index, time_scale_index] = this.selected_start_time;
      let tempEndTime = [];
      this.temp_selectable_end_times = tempEndTime;
      for (let [i, j] = [start_times_index, 0]; i < this.selectable_start_times.length; i++, j++) {
        if (this.selectable_start_times[i][1] === time_scale_index + j) {
          tempEndTime.push(this.selectable_end_times[i])
        }
      }
      this.temp_selectable_end_times = tempEndTime;
    },
    changeRoom() {
      // 改變房間時也需要重設時間
      const {date} = this;
      const url = '/api/orders/check_date_orders';
      const csrf = document.head.querySelector("meta[name=csrf-token]").content;
      axios.defaults.headers.common['X-CSRF-Token'] = csrf;
      axios.post(url, {
        date, key: this.room_key
      }).then((response) => {
        const {data} = response;
        // this.taken_orders = data.orders;
        this.selectable_start_times = data.selectable_start_times;
        this.selectable_end_times = data.selectable_end_times;
        this.selected_start_time = null;
        this.selected_end_time = null;
        // this.price = data.price;
      }).catch(error => console.log(error));
    },
    goNewOrder() {
      const {room_key, date, selected_start_time, selected_end_time} = this;
      const dateFormat = date && format(date, 'yyyy/MM/dd') || "";
      const start_time = selected_start_time && selected_start_time || "";
      const end_time = selected_end_time || "";
      const url = `/orders/new?room=${room_key}&date=${dateFormat}&start_time=${start_time}&end_time=${end_time}`;
      window.location.href = url;
    }
  }
}
</script>